module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_53304249_XL-small-be90dc5d71d9b7e798b5e6707c190568.jpg";